import { apiClient } from './clienteHttp';
import type { NotificacionesResponse } from './types';

export async function getNotificaciones(soloNoLeidas?: boolean): Promise<NotificacionesResponse> {
  const { data } = await apiClient.get('/notificaciones', {
    params: soloNoLeidas !== undefined ? { leidas: soloNoLeidas ? 'false' : 'true' } : undefined,
  });
  return data;
}

export async function marcarNotificacionLeida(id: string): Promise<{ id: string; leida: boolean; sin_leer: number }> {
  const { data } = await apiClient.put(`/notificaciones/${id}/leida`);
  return data;
}

export async function eliminarNotificacion(id: string): Promise<{ id: string; sin_leer: number }> {
  const { data } = await apiClient.delete(`/notificaciones/${id}`);
  return data;
}

export async function eliminarTodasNotificaciones(): Promise<{ sin_leer: number }> {
  const { data } = await apiClient.delete('/notificaciones/todas');
  return data;
}
